import { FC } from 'react'
import { Navigation } from '../../navigation/Navigation'
import { Toast } from '../../toast/Toast'
import { PlayerBar } from '../../audio/PlayerBar'
import Head from 'next/head'
import { useSession, signIn } from 'next-auth/react'
import { useEffect } from 'react'

interface PortalLayoutProps {
    children: React.ReactNode
}

export const PortalLayout: FC<PortalLayoutProps> = ({ children }) => {
    const { data: session } = useSession()

    useEffect(() => {
        if (session?.error === 'RefreshAccessTokenError') {
            signIn('keycloak') // Force sign in to hopefully resolve error
        }
    }, [session])

    return (
        <>
            <Head>
                <meta name="robots" content="noindex" />
            </Head>
            <Navigation isAuthenticated={session != null} app={'DevPortal'} />
            <Toast />
            {children}
            <PlayerBar app={'DevPortal'} />
        </>
    )
}
